import { deleteCookie } from '../../../../../utils/cookies';
import sType from '@/typings/storeType';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('UsersAPIService', usersAPIService);

    function usersAPIService(HttpService) {
        async function getMe() {
            var url = '/Users/GetMe';
            const user = await HttpService.get(url);

            // Start session recording only for genuine logins
            if (!user.UserImpersonatedFromId) {
                window.rumStartRecording();
            } else {
                // Stop recording just in case
                window.rumStopRecording();
            }

            rumSetUser({
                id: user.Id,
                name: user.Username,
                impersonatedFrom: user.UserImpersonatedFromId,
                createdDate: user.CreatedDate || ''
            });
            return user;
        }

        function logout() {
            return HttpService.get('/Users/Logout');
        }

        function getAllUsernames() {
            var url = '/Users';
            return HttpService.get(url);
        }

        function impersonate(username) {
            var data = {
                username: username
            };
            var url = '/Users/Impersonate?' + $.param(data);

            // Remove datadog session cookies so a new session is started
            deleteCookie('_dd_s', '/', '.customily.com');
            deleteCookie('_dd_s', '/', 'app.customily.com');
            return HttpService.get(url);
        }

        function getParentAccessRoles() {
            var url = '/Users/ParentAccessRoles';
            return HttpService.get(url);
        }

        function setRemoveBgAPIKey(key) {
            var url = '/Users/RemoveBg?key=' + key;
            return HttpService.post(url);
        }

        const setCutoutProAPIKey = (key) => {
            return HttpService.post(`/Users/CutoutPro?key=${key}`);
        };

        function verifyUser(token) {
            var data = {
                token: token
            };

            var url = '/Users/Verify?' + $.param(data);
            return HttpService.post(url);
        }

        function resendEmail(email) {
            var data = {
                email: email
            };

            var url = '/Users/Resend?' + $.param(data);
            return HttpService.post(url);
        }

        function resetPassword(password, confirmationPassword, username, token) {
            var data = {
                Username: username,
                Password: password,
                ConfirmationPassword: confirmationPassword,
                ResetToken: token
            };

            var url = '/Users/ResetPassword';
            return HttpService.post(url, data);
        }

        // mark userReview as showed to not show it again
        function userReviewShowed() {
            const url = '/Users/Review/Showed';
            return HttpService.post(url);
        }

        async function getStoresWithDebt(user) {
            return await HttpService.get('/Users/Billing/GetStoresWithDebt');
        }

        function checkTemplateAccess(templateId, accessLevelType) {
            var url = '/Product/CheckTemplateAccess/' + templateId + `?accessLevelType=${accessLevelType}`;
            return HttpService.get(url);
        }

        async function getStoresPlan(user) {
            const billings = await HttpService.get('/Users/Billing/Billings');
            const shopifyBillings = billings.filter((e) => e.storeType == sType.Shopify);

            const hasWooStores = user.Stores.some((s) => s.Type === 3);
            let hasWooAutoBilling = false;
            if (hasWooStores) {
                try {
                    hasWooAutoBilling = await HttpService.get('/Users/Billing/WooAutoBilling');
                } catch (error) {
                    console.error('Error getting if woo store has auto billing', error);
                }
            }

            // Business rules to display Order Manager:
            // If user has Shopify o Amazon stores always show it => wins over every other condition
            // If user has Etsy/TikTok with feature flag ON (means user has Etsy/TikTok with customily 2.0)
            // Custom should only display if *user* doesn't have customilyOptions ON -dependency between entities (stores / user)-
            // If user only has Woocommerce by itself won't show given that no previous rule applies

            const displayOrderManager = (function () {
                if (!user) return false;

                const accessRoles = user.AccessRoles.Serialized.split(',');
                const userStores = user.Stores;

                if (userStores.some((store) => [sType.Shopify, sType.Amazon, sType.WooCommerce].includes(store.Type))) {
                    return true;
                } else if (
                    userStores.some((store) => [sType.Etsy, sType.TikTok].includes(store.Type)) &&
                    user.featureFlags?.podProducts
                ) {
                    return true;
                } else if (
                    userStores.some((store) => store.Type === sType.Custom) &&
                    accessRoles.includes('custom-store')
                ) {
                    return true;
                } else {
                    return false;
                }
            })();

            return {
                hasShStores: Boolean(shopifyBillings.length),
                displayOrderManager,
                hasWooAutoBilling
            };
        }

        function userReviewFeedback(feedback) {
            const data = {
                Feedback: feedback
            };

            const url = '/Users/Review/Feedback';
            return HttpService.post(url, data);
        }

        return {
            logout: logout,
            getMe: getMe,
            getAllUsernames: getAllUsernames,
            impersonate: impersonate,
            getParentAccessRoles: getParentAccessRoles,
            verifyUser: verifyUser,
            resendEmail: resendEmail,
            resetPassword: resetPassword,
            setRemoveBgAPIKey: setRemoveBgAPIKey,
            userReviewShowed,
            userReviewFeedback,
            getStoresPlan,
            setCutoutProAPIKey,
            getStoresWithDebt,
            checkTemplateAccess
        };
    }
})();
